import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {MapComponent} from "../components/Map";
import { SocialIcon } from 'react-social-icons';
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Box
} from "@material-ui/core";
import {Phone, Home} from "@material-ui/icons";
import CardActionArea from "@material-ui/core/CardActionArea";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from '@material-ui/icons/Share';
import AppStore from "../AppStore";
import CardHeader from "@material-ui/core/CardHeader";
import Link from "@material-ui/core/Link";
import {FormattedMessage} from "react-intl";


const useStyles = makeStyles({
    root: {
        maxWidth: 600,
    },
    resortPhoto: {
        height: 180,
    },
    media: {
        height: 280,
    },

    inlineContact: {
        display: 'flex',
        alignItems: 'center',

        '& a' : {
            paddingTop: 4,
            marginLeft: 8
        },
        '& svg' : {
            fontSize: 20,
            color: '#999'
        }
    },
    socialIcon: {
        height: 40,
        width: 40
    },

    cardLocationSubheader: {
        fontSize: 14,
        marginTop: 8
    },
    cardLocationTitle: {
        fontSize: 20,
        fontWeight: 500,
        letterSpacing: .15
    }
});


export default function ContactPage()
{
    const appStore = React.useContext(AppStore);
    const resortData = appStore.getResortData();

    const clearUrl = function(url) {
        return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
    }
    const coordinates = resortData["location"]?.["coordinates"] ? resortData["location"]["coordinates"].split(";") : null;

    const share = () => {

        if (navigator.share) {
            navigator.share({
                title: resortData["name"],
                text: resortData["name"],
                url: 'https://maps.google.com/?q=' + coordinates[0] + ',' + coordinates[1]
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        }
        else {
            //alert('no share');
        }
    };

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Box>
                <Card>
                    {resortData["options"]["urlImageContact"] &&
                        <CardActionArea>
                            <CardMedia
                                className={classes.resortPhoto}
                                image={resortData["options"]["urlImageContact"]}
                                title={resortData.name}
                            />
                        </CardActionArea>
                    }
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="h2">
                            {resortData["name"]}
                        </Typography>

                        {resortData["options"]["description"] &&
                            <Typography variant="body2" color="textSecondary" component="p">
                                {resortData["options"]["description"]}
                            </Typography>
                        }

                        {resortData["contact"]?.["phone1"] &&
                            <Box className={classes.inlineContact} mt={1}>
                                <Phone/>
                                <Link href={'tel:' + resortData["contact"]["phone1"]} target={"_blank"} color={"inherit"}>
                                    <Typography variant="body2" color="textSecondary" component="span">
                                        {resortData["contact"]["phone1"]}
                                    </Typography>
                                </Link>
                            </Box>
                        }

                        {resortData["contact"]?.["web"] &&
                            <Box className={classes.inlineContact} mt={1}>
                                <Home />
                                <Link href={resortData["contact"]["web"]} target={"_blank"} color={"inherit"}>
                                    <Typography variant="body2" color="textSecondary" component="span">
                                        {clearUrl(resortData["contact"]["web"])}
                                    </Typography>
                                </Link>
                            </Box>
                        }

                        {(resortData["contact"]?.["facebook"] || resortData["contact"]?.["instagram"] || resortData["contact"]?.["twitter"] || resortData["contact"]?.["whatsapp"]) &&
                            <Box mt={3}>
                                <Typography variant="button" color="textSecondary" component="p">
                                    <FormattedMessage id="app.home.social-networks"/>
                                </Typography>
                            </Box>
                        }
                        <Box mt={1}>
                            {resortData["contact"]?.["facebook"] &&
                                <SocialIcon
                                    network={"facebook"}
                                    url={resortData["contact"]["facebook"]}
                                    target={'_blank'}
                                    style={{ height: 40, width: 40, marginRight: 10 }}
                                />
                            }
                            {resortData["contact"]?.["instagram"] &&
                                <SocialIcon
                                    network={"instagram"}
                                    url={resortData["contact"]["instagram"]}
                                    target={'_blank'}
                                    style={{ height: 40, width: 40, marginRight: 10 }}
                                />
                            }
                            {resortData["contact"]?.["twitter"] &&
                                <SocialIcon
                                    network={"twitter"}
                                    url={resortData["contact"]["twitter"]}
                                    target={'_blank'}
                                    style={{ height: 40, width: 40, marginRight: 10 }}
                                />
                            }
                            {resortData["contact"]?.["whatsapp"] &&
                                <SocialIcon
                                    network={"whatsapp"}
                                    url={'https://wa.me/' + resortData["contact"]["whatsapp"]}
                                    target={'_blank'}
                                    style={{ height: 40, width: 40, marginRight: 10 }}
                                />
                            }
                        </Box>

                    </CardContent>
                </Card>
            </Box>

            {resortData["location"]?.["address"] &&
                <Box mt={3}>
                    <Card>

                        <CardHeader
                            classes={{
                                title: classes.cardLocationTitle,
                                subheader: classes.cardLocationSubheader
                            }}
                            title={<FormattedMessage id="app.contact.location"/>}
                            subheader={resortData["location"]["address"]}
                            action={
                                navigator.share &&
                                    <IconButton aria-label="share" onClick={share}>
                                        <ShareIcon/>
                                    </IconButton>
                            }
                        >
                        </CardHeader>

                        {coordinates &&
                            <CardMedia className={classes.media}>
                                <MapComponent
                                    lat={parseFloat(coordinates[0])}
                                    lng={parseFloat(coordinates[1])}
                                />
                            </CardMedia>
                        }
                    </Card>
                </Box>
            }
        </div>
    )
}
